import React from "react";
import { cn } from "../../lib/cn";

export function ImagePreviewGroup({ preview, items, children }) {
  return <span className="inline-flex gap-2 flex-wrap">{children}</span>;
}

function ImageInner({
  src,
  width,
  height,
  className,
  style,
  fallback,
  preview,
  alt,
}) {
  return (
    <img
      src={src || fallback}
      alt={alt || ""}
      className={cn(
        "rounded-md object-cover border border-slate-100 bg-slate-50",
        preview && "cursor-zoom-in",
        className
      )}
      style={{
        width: width ?? undefined,
        height: height ?? undefined,
        ...style,
      }}
    />
  );
}

ImageInner.PreviewGroup = ImagePreviewGroup;

export function Image(props) {
  return <ImageInner {...props} />;
}

Image.PreviewGroup = ImagePreviewGroup;
